import React, { useState, useEffect, useRef } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import DocumentGrid from './DocumentGrid';
import { getAllSupportedLanguages } from '../../utils/services/languageApi';
import styled from 'styled-components';

const AppContainer = styled.div`
  * {
    font-family: ui-sans-serif, system-ui, sans serif !important;
  }
  width: 95%;
  margin-left: 5%;
  display: flex;
  height: 100vh;
  background: linear-gradient(to bottom right, #f9fafb, #f3f4f6);
`;

const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export default function NewTemplateSection() {
  const [selectedView, setSelectedView] = useState('documents');
  const [organizationView, setOrganizationView] = useState('categories');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState('all');
  const [sortBy, setSortBy] = useState('date');
  const [qaStatus, setQaStatus] = useState(null);
  const [allLanguages, setAllLanguages] = useState([]);

  useEffect(() => {
    const fetchLanguageList = async () => {
      try {
        const response = await getAllSupportedLanguages();
        if (response?.statusCode === 109 && response?.data) {
          setAllLanguages(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchLanguageList();
  }, []);

  const searchInputRef = useRef(null);
  const clearAllFilters = () => {
    setSearchQuery('');
    setSelectedTags([]);
    setSelectedFolder('all');
    setSortBy('date');
    setQaStatus(null);
    searchInputRef.current.value = '';
  };

  return (
    <AppContainer>
      {/* Sidebar */}
      <Sidebar
        organizationView={organizationView}
        setOrganizationView={setOrganizationView}
        selectedView={selectedView}
        collapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
        setSearchQuery={setSearchQuery}
        selectedTags={selectedTags}
        setSelectedTags={setSelectedTags}
        selectedFolder={selectedFolder}
        onSelectFolder={setSelectedFolder}
        qaStatus={qaStatus}
        setQaStatus={setQaStatus}
        clearAllFilters={clearAllFilters}
        allLanguages={allLanguages}
        searchInputRef={searchInputRef}
      />

      {/* Main Content */}
      <MainContent>
        <TopBar
          selectedView={selectedView}
          onViewChange={setSelectedView}
          sidebarCollapsed={sidebarCollapsed}
        />

        <DocumentGrid
          selectedView={selectedView}
          organizationView={organizationView}
          searchQuery={searchQuery}
          qaStatus={qaStatus}
          selectedTags={selectedTags}
          selectedFolder={selectedFolder}
          sortBy={sortBy}
          setSortBy={setSortBy}
          clearAllFilters={clearAllFilters}
          allLanguages={allLanguages}
        />
      </MainContent>
    </AppContainer>
  );
}
